module.exports = __webpack_public_path__ + "img/erp02.d23d7fab.jpg";